import {
  FETCH_ALL_DEPOSIT_SYSTEMS,
  ADD_NULL_DEPOSIT_SYSTEM,
} from '../../mutation-types';

export default {
  [FETCH_ALL_DEPOSIT_SYSTEMS](state, depositSystems) {
    state.all = depositSystems;
  },

  [ADD_NULL_DEPOSIT_SYSTEM](state) {
    state.all.splice(0, 0, { id: '', name: '' });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/depositSystem/mutations.js